/**
 * 薛煜如 表格配置工具
 */

/**
 * 递归初始化列配置
 * @param {} columns 列配置
 */
function recursionInitColumns(columns){
  if(!columns || columns.length < 1) return
  columns.forEach(item => {
    //默认居中
    !item.align && (item.align = 'center')
    //存在type将type作为class追加
    item.type && (item.className ? item.className += ` ${item.type}` : item.className = item.type)
    //自动配置动态插槽
    if(item.type || item.slot){
      item.scopedSlots = {customRender: item.key || item.dataIndex, filterIcon: 'filterIcon'}
    }
    //子配置递归
    item.children && recursionInitColumns(item.children)
  })
}

/**
 * 递归获取动态插槽
 * @param {*} columns 
 * @param {*} slotList 
 */
function recursionDynamicSlotHandler(columns, slotList){
  if(!columns || columns.length < 1) return
  if(!slotList) throw new Error("用于存储的插槽list不能为空")

  columns.forEach(item => {
    if(item.scopedSlots){
      slotList.push({
        ...item.scopedSlots,
        key: item.dataIndex,
        type: item.type
      })
    }
    //子配置递归
    item.children && recursionDynamicSlotHandler(item.children, slotList)
  })
}
import Vue from "vue"
export default {
  /** 字段转换器 */
  async columnsConvert(headApi, columns){
    // 自定义表头
    let customHeads = []
    if(headApi){
      const {data} = await headApi()
      customHeads = data || []
    }
    customHeads.forEach(item => {
      if(columns.findIndex(column => column.dataIndex == item.id) != -1){
        return
      }
      columns.push({
        dataIndex: item.id,
        title: item.label
      })
    })
  },
  /** 设置列自定义 */
  setWorkOrderColumnsCustom(origColumns){
    return origColumns.filter((item)=>{
      return Vue.prototype.$defineTabEnable(item.customCode, 'WORK_ORDER')==true
    })
  },
  /** 字段处理器 */
  columnsHandler(origColumns, page, pageSize, rowKey, indexWidth){
    let columns = []
    console.log('indexWidth', indexWidth)
    indexWidth && columns.push({
      title: '序号',
      width: indexWidth,
      fixed: true,
      customRender: (text, record, index) => {
        let i = ''
        const key = record[rowKey]
        if(isNaN(key) || key > 0){
          i = `${((page - 1) * pageSize) + index + 1}`
        }
        return i
      },
    })
    columns.push(...origColumns)
    recursionInitColumns(columns)
    return columns
  },
  /** 动态插槽处理 */
  dynamicSlotHandler(columns){
    let slotList = []
    recursionDynamicSlotHandler(columns, slotList)
    return slotList
  }
}